export const roleMapping: { [key: string]: string } = {
  0: 'User',
  1: 'Organization Admin',
  2: 'Platform Admin',
};

// Import from centralized file type configuration
export { sampleFileExtensions } from './config/sampleFileTypes';

export const LSM_PIPELINE_NAME = 'lsm-inference-pipeline';

/**
 * File-name token that marks a results export the analytes-table filters
 * narrowed. A reader tells a partial file from a full one at rest.
 *
 * "Full" means what the filters of that surface expose with nothing
 * deselected. The identification table shows no chip for the unscored
 * bucket, so its unmarked file holds no unscored rows.
 */
export const FILTERED_EXPORT_FILENAME_MARKER = 'filtered';

import { ConfigEditorValues } from './interfaces/job';
export const defaultConfigEditorValues: ConfigEditorValues = {
  mode: 'standard',
  selectedModel: null,
  analyteSets: [],
  restrictedAnalyteSets: [],
  qcAnalyteSets: [],
  restrictedQcAnalyteSets: [],
  selectedIdModel: null,
  selectedQuantModel: null,
  mzWindowPpm: '4',
};
